import {addActionSheet} from './action_sheet.js';

$(document)
    .on('ajaxError', (event, jqxhr) => {
        if (jqxhr.hasOwnProperty("responseJSON")) {
            const json_response = jqxhr.responseJSON;

            if (json_response.hasOwnProperty("exception")) {
                const json_exception = json_response.exception;
                if (json_exception.hasOwnProperty("redirect_url")) {
                    location.href = json_response.exception.redirect;

                } else {
                    addActionSheet(
                        {
                            type: 'error',
                            heading: json_exception.code,
                            message: json_exception.message,
                        },
                        0
                    );
                }

            } else if (json_response.hasOwnProperty("notification")) {
                addActionSheet(json_response.notification, 0);
            }

        } else {
            addActionSheet(
                {
                    type: 'error',
                    message: "Mal-format form response",
                    heading: "Unexpected error"
                },
                0
            );
        }
    })
    .on('ajaxComplete', () => {
        //console.log("MASTER ajaxComplete");
    })
    .on('ajaxSend', event => {
        //console.log("MASTER ajaxSend");
    })
    .on('ajaxSuccess', () => {
        //console.log("MASTER ajaxSuccess");
    });
